import React, { useContext } from "react"
import { useWatch } from "react-hook-form"

import classNames from "classnames"

import { InputContext } from "shared/ui/input/Input"

import { MarkdownPreview, MarkdownPreviewProps } from "./MarkdownPreview"

export interface ReadonlyMarkdownProps extends MarkdownPreviewProps {
  render?: (value: string) => React.JSX.Element
  children?: React.ReactNode | React.ReactNode[]
}

function ReadonlyMarkdownBase({
  className,
  children,
  render,
  value,
  ...props
}: ReadonlyMarkdownProps) {
  const { readonly, loading } = useContext(InputContext)

  if (!readonly || loading) {
    return null
  }

  if (children) {
    return children as React.JSX.Element
  }

  if (typeof value !== "string") {
    return null
  }

  if (render) {
    return render(value)
  }

  return (
    <MarkdownPreview
      {...props}
      value={value}
      className={classNames("input__readonly", className)}
    />
  )
}

function HookFormReadonlyMarkdown(props: ReadonlyMarkdownProps) {
  const { name } = useContext(InputContext)
  const value = useWatch({ name }) ?? ""

  return <ReadonlyMarkdownBase {...props} value={value} />
}

function ReadonlyMarkdownComponent(props: ReadonlyMarkdownProps) {
  const { name } = useContext(InputContext)

  if (name) {
    return <HookFormReadonlyMarkdown {...props} />
  }
  return <ReadonlyMarkdownBase {...props} />
}

export const ReadonlyMarkdown = React.memo(ReadonlyMarkdownComponent)
